import { render, staticRenderFns } from "./ExecutiveCommitteeMessage.vue?vue&type=template&id=49687c26&scoped=true&"
import script from "./ExecutiveCommitteeMessage.vue?vue&type=script&lang=js&"
export * from "./ExecutiveCommitteeMessage.vue?vue&type=script&lang=js&"
import style0 from "./ExecutiveCommitteeMessage.vue?vue&type=style&index=0&id=49687c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49687c26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
